import styled from 'styled-components';

export const FormContainer = styled.div`
  margin-top: 40px;
`;

export const CheckboxContainer = styled.div`
  height: 32px;
  display: flex;
  margin-top: 8px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  margin-top: 40px;
  align-items: center;
  gap: ${(p) => (p.theme.responsive.isDesktop ? '32px' : '24px')};
  flex-direction: ${(p) => (p.theme.responsive.isDesktop ? 'row' : 'column')};
  justify-content: ${(p) =>
    p.theme.responsive.isDesktop ? 'space-between' : 'unset'};
`;
